import util from '../../lib/util';
import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Campaign from '../../entities/campaign';
import Lead from '../../entities/lead';
import Task from '../../entities/task';
import Document from '../../entities/document';
import Comment from '../../entities/comment';
export function deleteCampaign(campaign: Campaign, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = campaign.id;}
const _work = workingSet();
store.getState().leads.getMappingFor('campaignId', campaign.id).filter(leadTemp => leadTemp.status !== 'D').forEach(leadTemp => {
const _lead = ((_work.get('lead:' + leadTemp.id) ?? leadTemp) as Lead).clone();
_lead.status = 'U';
_lead.addedOn = newHRTimestamp();
_lead.addedBy = getCurrentUserId();
_lead.importSource = targetImportSource;
_lead.importId = mergeId;
_lead.campaigns = _lead.campaigns?.filter(id => id !== campaign.id) || [];

_work.set('lead:' + _lead.id, _lead);
store.dispatch(Actions.LeadActions.saveLeadQueue(_lead));
});


findAll<Task>('tasks').filter(taskTemp => taskTemp.status !== 'D' && taskTemp.hasOwnProperty('tieIns')).filter(taskTemp => !!taskTemp.tieIns?.some(f => {return 'Campaign' === f.entity && f.id === campaign.id;})).forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
_task.tieIns = [...(_task.tieIns || [])].filter(f => !('Campaign' === f.entity && f.id === campaign.id));
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
_work.set('task:' + _task.id, _task);
store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
});
campaign.status = 'D';
campaign.addedOn = newHRTimestamp();
campaign.addedBy = getCurrentUserId();
campaign.importSource = targetImportSource;
campaign.importId = mergeId;
store.dispatch(Actions.CampaignActions.removeCampaignQueue(campaign));
findAll<Document>('documents').filter(documentTemp => documentTemp.entityType === 'campaign' && documentTemp.entityId === campaign.id && documentTemp.status !== 'D').forEach(documentTemp => {
const _document = ((_work.get('document:' + documentTemp.id) ?? documentTemp) as Document).clone();
_document.status = 'D';
_document.addedOn = newHRTimestamp();
_document.addedBy = getCurrentUserId();
_document.importSource = targetImportSource;
_document.importId = mergeId;
_work.set('document:' + _document.id, _document);
store.dispatch(Actions.DocumentActions.removeDocumentQueue(_document));
});
findAll<Comment>('comments').filter(commentTemp => commentTemp.entityType === 'campaign' && commentTemp.entityId === campaign.id && commentTemp.status !== 'D').forEach(commentTemp => {
const _comment = ((_work.get('comment:' + commentTemp.id) ?? commentTemp) as Comment).clone();
_comment.status = 'D';
_comment.addedOn = newHRTimestamp();
_comment.addedBy = getCurrentUserId();
_comment.importSource = targetImportSource;
_comment.importId = mergeId;
_work.set('comment:' + _comment.id, _comment);
store.dispatch(Actions.CommentActions.removeCommentQueue(_comment));
});
}
export function replaceCampaign(campaign: Campaign, replaceWith: Campaign, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = campaign.id;}
const _work = workingSet();
store.getState().leads.getMappingFor('campaignId', campaign.id).filter(leadTemp => leadTemp.status !== 'D').forEach(leadTemp => {
const _lead = ((_work.get('lead:' + leadTemp.id) ?? leadTemp) as Lead).clone();
_lead.status = 'U';
_lead.addedOn = newHRTimestamp();
_lead.addedBy = getCurrentUserId();
_lead.importSource = targetImportSource;
_lead.importId = mergeId;
_lead.campaigns = _lead.campaigns?.map(id => (id === campaign.id) ? replaceWith.id : id) || [];

_work.set('lead:' + _lead.id, _lead);
store.dispatch(Actions.LeadActions.saveLeadQueue(_lead));
});


findAll<Task>('tasks').filter(taskTemp => taskTemp.status !== 'D' && taskTemp.hasOwnProperty('tieIns')).filter(taskTemp => !!taskTemp.tieIns?.some(f => {return 'Campaign' === f.entity && f.id === campaign.id;})).forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
_task.tieIns = [...(_task.tieIns || [])].map(f => {if ('Campaign' === f.entity && f.id === campaign.id) {const _f = {...f}; _f.id = replaceWith.id; return _f;} else return f;});
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
_work.set('task:' + _task.id, _task);
store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
});
findAll<Document>('documents').filter(documentTemp => documentTemp.entityType === 'campaign' && documentTemp.entityId === campaign.id && documentTemp.status !== 'D').forEach(documentTemp => {
const _document = ((_work.get('document:' + documentTemp.id) ?? documentTemp) as Document).clone();
_document.entityId = replaceWith.id;
_document.status = 'U';
_document.addedOn = newHRTimestamp();
_document.addedBy = getCurrentUserId();
_document.importSource = targetImportSource;
_document.importId = mergeId;
_work.set('document:' + _document.id, _document);
store.dispatch(Actions.DocumentActions.saveDocumentQueue(_document));
});
findAll<Comment>('comments').filter(commentTemp => commentTemp.entityType === 'campaign' && commentTemp.entityId === campaign.id && commentTemp.status !== 'D').forEach(commentTemp => {
const _comment = ((_work.get('comment:' + commentTemp.id) ?? commentTemp) as Comment).clone();
_comment.entityId = replaceWith.id;
_comment.status = 'U';
_comment.addedOn = newHRTimestamp();
_comment.addedBy = getCurrentUserId();
_comment.importSource = targetImportSource;
_comment.importId = mergeId;
_work.set('comment:' + _comment.id, _comment);
store.dispatch(Actions.CommentActions.saveCommentQueue(_comment));
});
return campaign;
}
export function deleteImpactCampaign(campaign: Campaign) {
const impacts: string[] = [];
const state = store.getState();
const leadCampaignsImpact = state.leads.getMappingFor('campaignId', campaign.id).filter(lead => lead.status !== 'D');
leadCampaignsImpact.forEach(() => impacts.push('leads'));


const taskTieInsImpact = findAll<Task>('tasks').filter(task => task.status !== 'D' && task.hasOwnProperty('tieIns')).filter(task => !!task.tieIns?.some(f => {return 'Campaign' === f.entity && f.id === campaign.id;}));
taskTieInsImpact.forEach(() => impacts.push('tasks'));
return util.countDistinct(impacts);
}
